import React, { FC, useCallback, useMemo, useState } from 'react';
import {
	getEntityById,
	getLabelFromArrayOfKeys,
	stopDefaultEvents,
} from '../../utils/DataAccessUtils';
import { patchUpdateACCAuditForNeedsVerification } from '../../thunks/acc_audits_thunks';
import { ROLE_TYPES } from '../../utils/DataConstants';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Dropdown, Menu, message, Spin } from 'antd';
import {
	ACC_AUDIT_MATCH_STATUSES,
	NEEDS_VERIFICATION_VALUE_WITH_LABEL,
} from '../../utils/AssetCycleUtils';
import { DownOutlined, LoadingOutlined } from '@ant-design/icons';
import { withUserType } from '../withUserType';

const ACCAuditNeedsVerificationAction: FC<any> = ({
	accAudit,
	updateVerificationAction,
}): React.ReactElement => {
	const [updating, setUpdating] = useState(null);

	const changeNeedsVerificationStatus = useCallback(
		(needsVerificationAction) => () => {
			setUpdating(true);
			updateVerificationAction(accAudit.assetCycleCountRunId, accAudit.assetId, {
				needsVerificationAction,
			})
				.catch(message.error)
				.finally(() => setUpdating(false));
		},
		[accAudit, updateVerificationAction]
	);

	const needsVerificationMenu = useMemo(
		() => (
			<Menu selectedKeys={[accAudit.needsVerificationAction]}>
				{NEEDS_VERIFICATION_VALUE_WITH_LABEL.filter((_) => !_.hidden).map((menu) => (
					<Menu.Item key={menu.key} onClick={changeNeedsVerificationStatus(menu.key)}>
						{menu.label}
					</Menu.Item>
				))}
			</Menu>
		),
		[accAudit, changeNeedsVerificationStatus]
	);

	return accAudit.matchStatus === ACC_AUDIT_MATCH_STATUSES.NeedsVerification ? (
		<div onClick={stopDefaultEvents}>
			<Dropdown overlay={needsVerificationMenu}>
				<div className="flex flex-row items-center gap-2 text-[#FF2D2D]">
					<span>
						{getLabelFromArrayOfKeys(
							NEEDS_VERIFICATION_VALUE_WITH_LABEL,
							accAudit.needsVerificationAction,
							'key',
							'label'
						) || '--'}
					</span>
					<div>
						<DownOutlined />
					</div>
					{updating ? (
						<div className="ml-2">
							<Spin indicator={<LoadingOutlined style={{ fontSize: 16 }} spin />} />
						</div>
					) : null}
				</div>
			</Dropdown>
		</div>
	) : null;
};

const mapStateToProps = (state, ownProps) => ({
	cycleRun: getEntityById(ownProps.match.params.id, state.cycle_runs),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	updateVerificationAction: (accRunId, assetId, entity) =>
		dispatch(patchUpdateACCAuditForNeedsVerification(ownProps.userType)(accRunId, assetId, entity)),
});

export default withRouter(
	withUserType(connect(mapStateToProps, mapDispatchToProps)(ACCAuditNeedsVerificationAction as any))
);
